import {Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class BulkUploadFeatureHelperService {
    private _isBulkUploadEnabled$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
    private _isAIBulkUploadEnabled$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

    isBulkUploadEnabled$: Observable<boolean> = this._isBulkUploadEnabled$.asObservable();
    isAIBulkUploadEnabled$: Observable<boolean> = this._isAIBulkUploadEnabled$.asObservable();

    constructor() {
        this._isBulkUploadEnabled$.next(environment.enableBulkUpload === true);
        this._isAIBulkUploadEnabled$.next(environment.enableAIBulkUpload === true);
    }
}
